import { ElementState, Preview } from "@creatomate/preview";
import { ColorResult } from "react-color";
import { ANIMATION_SUBTYPES, ANIMATIONS } from "../../utils/constants";

export const TRANSITION_ANIMATION_SUBTRACTION = 0.5;

export enum Context {
  Media = "media",
  Text = "text",
  Subtitle = "subtitle"
}

export enum Mode {
  Enter = "enter",
  Exit = "exit",
  Transition = "transition"
}

export type Type = keyof typeof ANIMATIONS;
export type Subtype = keyof typeof ANIMATION_SUBTYPES;
export type Time = string | number;
type Duration = number;

export interface ScreenProps {
  context: Context;
  preview: Preview;
  activeElement: ElementState;
}

export interface HandleSelectAnimationProps {
  time: Time;
  type: Type;
  subtype?: Subtype;
  duration?: Duration;
  color?: ColorResult;
}

export interface ElementProps {
  type: Type;
  label: string;
  isSelected: boolean;
  order: number;
  onClick: () => void;
}

export type SettingsOnChangeProps = {
  subtype: Subtype;
  duration: Duration;
  color?: ColorResult;
}

export interface SettingsProps {
  type: Type;
  selectedAnimation: Record<string, any>;
  order: number;
  onChange: ({ subtype, duration, color }: SettingsOnChangeProps) => void;
}
